import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Grid2 as Grid, Typography, useTheme} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

interface FormGroupProps {
  title: string | React.ReactNode;
  expanded?: boolean;
  children: React.ReactNode;
}

export default function FormGroup({title, children, expanded = true}: FormGroupProps) {
  const theme = useTheme();

  return <Accordion defaultExpanded={expanded} style={{color: theme.palette.primary.main}} slotProps={{ heading: { component: 'h2' } }}>
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      id="basicReportDetails">
      <Typography>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails>
      <Grid container spacing={2}>
        {children}
      </Grid>
    </AccordionDetails>
  </Accordion>;
}
